export const ABBREVIATIONS = ['IP', 'URL', 'IIS', 'ISP', 'API', 'SPF', 'CVE', 'CVSS']
